// React imports.
import React, { Component } from "react";
import ReactTooltip from 'react-tooltip';

const DataFields = ({ fields, selectedCategoryId, toggleFieldSelected }) => (
  <div className="verticalList" >
    
    {fields
      .filter(f => f.subCategoryId == selectedCategoryId)
      .map(field => (
        <React.Fragment>
          <ReactTooltip delayShow={400} backgroundColor="WhiteSmoke" textColor="black"/>
          <label key={field.tableFieldId}
            data-tip={field.tableFieldTooltip}>
            <input type="checkbox" value={field.tableFieldId}
              checked={field.tableFieldSelected}
              onChange={e => toggleFieldSelected(field.tableFieldId)} />
            <span >{field.tableFieldDescription}</span>
          </label>
        </React.Fragment>
      ))}

  </div>
);

export default DataFields;
